module.exports = __webpack_public_path__ + "img/asecna-logo.c4fb5e8e.webp";